import { Box, Button } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import TodayIcon from "@mui/icons-material/Today";
import DatePicker from "../common/DatePicker";

export default function SailDate(props) {
  return (
    <Box mt={0} align="center">
      <h2 className="sectionTitle center">Date Sailed</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md="auto">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="form-input"
            size="large"
            onClick={(e) => props.sailDateNowHandler(e)}
            key={"sail_date_now"}
            startIcon={<TodayIcon />}
          >
            {"Now"}
          </Button>
        </Grid>
        <Grid item xs={12} md="auto">
          <DatePicker
            label={"Sail Date"}
            displayDate={props.display_date_sail}
            class={"sail_date"}
            handleDateChange={props.handleSailDateChange}
            name={"date_sail"}
            dateHelperText="Enter date and time sailed"
          />
          <HelpText helpText={getHelpText(props.helpText, "sail_date")} />
        </Grid>
      </Grid>
    </Box>
  );
}
